import { useGetUserConfigSetting, useSaveUserConfigSetting } from 'api';
import { useAuth } from 'auth';
import * as React from 'react';
import { useOnboarding } from './use-onboarding';

export const ONBOARDING_RELEASE_DATE = '2026-10-07T09:00:00Z';
export const ONBOARDING_SETTING_KEY = 'openfield-web.onboarding.opened';

export const OnboardingAutoOpen: React.FC = () => {
    const { user, isAuthenticated, indeterminate } = useAuth();
    const { isEnabled, url, type, open } = useOnboarding();
    const hasOpened = React.useRef(false);

    const isNewUser = !!user?.created_at && new Date(user.created_at) >= new Date(ONBOARDING_RELEASE_DATE);
    const isHelper = /^Helper\d+$/.test(user?.name ?? '');
    const isCandidate =
        !indeterminate &&
        isAuthenticated &&
        isEnabled === true &&
        !!type &&
        (isNewUser || type === 'upgrade') &&
        !isHelper;

    const setting = useGetUserConfigSetting(ONBOARDING_SETTING_KEY, { enabled: isCandidate });
    const { mutate: saveSetting } = useSaveUserConfigSetting();

    React.useEffect(() => {
        const saved = setting.data?.value;
        if (hasOpened.current || !isCandidate || !url || !setting.isFetched || saved === type) {
            return;
        }

        hasOpened.current = true;

        const isOldRecord = !!saved && saved !== 'new' && saved !== 'upgrade';

        if (isOldRecord || open()) {
            saveSetting({ settingKey: ONBOARDING_SETTING_KEY, value: type });
        }
    }, [isCandidate, url, type, setting.isFetched, setting.data, open, saveSetting]);

    return null;
};
